import {
  ConnectionTestOutcomeSchema,
  ConnectionTestTargetSchema,
} from "@redotech/redo-integrations-definitions-common/connection-test";
import * as z from "zod";

/** Tests one of the team's integrations of any family; testable is false when it has no connection test. */
export const testIntegrationConnection = {
  name: "testIntegrationConnection" as const,
  input: z.object({ target: ConnectionTestTargetSchema }),
  output: z.discriminatedUnion("testable", [
    z.object({ testable: z.literal(false) }),
    z.object({
      testable: z.literal(true),
      outcome: ConnectionTestOutcomeSchema,
    }),
  ]),
};
